import {Row} from "react-bootstrap";
import {useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {markTaskAsComplete, resetMarkTaskAsComplete} from "../actions/ProcessActions";
import Loader from "../components/Loader";

function ResponsePage() {
    const history = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const [showMessage, setShowMessage] = useState({
        display: false,
        message: "",
        text: "",
    });

    const markTaskAsCompleteDetails = useSelector(state => state.markTaskAsComplete);
    const {loading} = markTaskAsCompleteDetails;

    useEffect(() => {
        if (markTaskAsCompleteDetails.mark_task === true) {
            dispatch(resetMarkTaskAsComplete())
            setShowMessage({
                display: true,
                message: "Thank you! Task marked as complete",
                text: "You will be redirected in a few seconds",
            })
            setTimeout(() => {
                history("/")
            }, 5000);
        }
        if (markTaskAsCompleteDetails.error) {
            setShowMessage({
                display: true,
                message: "Error! Task could not be marked as complete",
                text: "You will be redirected in a few seconds",
            })
            setTimeout(() => {
                history("/")
            }, 5000);
        }
    }, [markTaskAsCompleteDetails]);

    const completeTask = () => {
        const processTaskId = params.get("processTaskId");
        const assignment = params.get("assignment");
        const clientId = params.get("clientId");

        if (processTaskId && assignment && clientId) {
            dispatch(markTaskAsComplete(processTaskId, assignment, clientId));
        } else {
            setShowMessage({
                display: true,
                message: "Error! Task could not be marked as complete due to wrong parameters",
                text: "You will be redirected in a few seconds",
            })
            setTimeout(() => {
                history("/")
            }, 5000);
        }
    }

    return (
        <Row className="login-background">
            {loading && <Loader/>}
            <div id="main">
                {!showMessage.display && <div className="fof">
                    <h2>Are you sure you would like to complete task?</h2>
                    <div className="process-complete">
                        <button type="button"
                                className="add-button button-solid reset-filter-button width-medium-btn"
                                onClick={completeTask}>
                            Complete Task
                        </button>
                    </div>
                </div>}
                {showMessage.display && <div className="fof">
                    <h1>{showMessage.message}</h1>
                    <div className="">
                        <span className="span-error-page">{showMessage.text}</span>
                    </div>
                </div>}
            </div>
        </Row>
    );
}

export default ResponsePage;